import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { useUser } from 'src/hook/useUser'
import { IMAGES } from 'src/assets'
import { AvatarProps } from './avatar.types'
import { Image } from './avatar.styles'

const Avatar = ({ small, className }: AvatarProps) => {
  const { authStatus, avatar, user } = useUser()

  const src = authStatus === AuthStatus.AUTHENTICATED ? avatar : IMAGES.AVATAR_OWNER_DEFAULT

  return <Image src={src} small={Boolean(small)} alt={user?.socialName} className={className} />
}

export default Avatar
